import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import StaffListTable from 'components/organismos/master/general/staff/StaffListTable';
import BlockUI from 'components/molecules/BlockUi';
import useCurrentRoleScreen from 'hooks/useCurrentRoleScreen';
import { useStaffList } from './hooks';

const StaffsPage: React.FC = () => {
  const roleScreen = useCurrentRoleScreen('/staffs');

  const {
    staffList,
    fetchData,
    executiveId,
    setExecutiveId,
    employmentId,
    setEmploymentId,
    orgCode,
    setOrgCode,
    stateStatus,
    setStateStatus,
    blocking,
    categoryArr,
    setCategoryAr,
    menuType,
    orgStatus,
    setOrgStatus
  } = useStaffList(roleScreen?.menuId);

  return (
    <SidebarTemplate
      pageTitle="スタッフマスタ"
    >
      <BlockUI blocking={blocking}>
        <StaffListTable
          staffList={staffList}
          fetchData={fetchData}
          executiveId={executiveId}
          setExecutiveId={setExecutiveId}
          employmentId={employmentId}
          setEmploymentId={setEmploymentId}
          orgCode={orgCode}
          setOrgCode={setOrgCode}
          stateStatus={stateStatus}
          setStateStatus={setStateStatus}
          categoryArr={categoryArr}
          setCategoryAr={setCategoryAr}
          menuType="0"
          orgStatus={orgStatus}
          setOrgStatus={setOrgStatus}
          roleScreen={roleScreen}
        />
      </BlockUI>
    </SidebarTemplate>
  );
};

export default StaffsPage;
